import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    title: String,
    message: String,
    icon: { type: String, default: "warning" }
  }

  confirm(event) {
    const form = event.target.closest("form")

    if (form && !form.checkValidity()) {
      form.reportValidity()
      return
    }
    event.preventDefault()

    Swal.fire({
      title: this.titleValue || "Você tem certeza?",
      text: this.messageValue || "",
      icon: this.iconValue,
      showCancelButton: true,
      confirmButtonColor: "#48c78e",
      confirmButtonText: "Sim",
      cancelButtonText: "Não"
    }).then((result) => {
      if (result.isConfirmed) {
        if (form) {
          form.requestSubmit()
        } else {
          event.target.click()
        }
      }
    })
  }
}
